import { inject, Injectable } from '@angular/core';
import { map, Observable, of, ReplaySubject } from 'rxjs';
import { STORAGE_ITEM } from '~models/enums/storage-item.enum';
import { ILoginResponseData } from '~models/interfaces/login.interface';
import { IToken, ITokens } from '~models/interfaces/token.interface';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private tokens$: ReplaySubject<ITokens | null> = new ReplaySubject(1);

  private authService = inject(AuthService);

  constructor() { }

  public getAccessToken(): Observable<IToken | null> {
    return this.tokens$.pipe(map((value: ITokens | null) => (value ? { token: value.access, expiresAt: value.accessExpireTime } : null)));
  }

  public getRefreshToken(): Observable<IToken | null> {
    return this.tokens$.pipe(map((value: ITokens | null) => (value ? { token: value.refresh, expiresAt: value.refreshExpireTime } : null)));
  }

  public setTokens(authData: ILoginResponseData): void {
    const tokens: ITokens = {
      access: authData.access,
      // accessExpireTime: authData.accessExpireTime ?? 0,
      refresh: authData.refresh,
      // refreshExpireTime: authData.refreshExpireTime ?? 0,
    };
    localStorage.setItem(STORAGE_ITEM.TOKENS, JSON.stringify(tokens));

    this.tokens$.next(tokens);
  }

  public initTokens(): Observable<boolean> {
    const storageTokens = localStorage.getItem(STORAGE_ITEM.TOKENS);
    if (storageTokens) {
      const tokens: ITokens = JSON.parse(storageTokens);
      this.tokens$.next(tokens);
      return this.authService.check();
    } else {
      this.tokens$.next(null);
      return of(false);
    }
  }

  public dropTokens(): void {
    localStorage.removeItem(STORAGE_ITEM.TOKENS);
    this.tokens$.next(null);
  }
}
